import React, { useMemo } from "react";
import { Collapse, Form, Typography } from "antd";
import useAPIResponse from "hooks/useAPIResponse";
import { useEffect, useRef, useState } from "react";
import TeamsAPI from "restAPI/TeamsAPI";
import { generateFormFields, parseSelectOptions } from "utils/formUtils";
import { getApprovalWorkflowFields } from "views/Inventory/Project/utils";
import _, { find } from "lodash";
import Vocabulary from "components/Vocabulary";
import { useActiveUserContext } from "contexts/ActiveUserContext";
import { useFeatureFlag } from "contexts/FeatureFlagContext";

const ApprovalWorkflow = ({ form, initialFormValues, activeUserOptions, approversRef }) => {
  const tabRef = useRef();
  const [activeKey, setActiveKey] = useState('approval');
  const userContext = useActiveUserContext(); 
  const featureFlags = useFeatureFlag(); 
  const newApprovalFlow = featureFlags?.EXCEPTION_MODULE_UPDATE;

  const [approvalUsersList] = useAPIResponse(() => {
    const { promise, cancel } = TeamsAPI.getApprovers();
    const promise2 = promise.then(parseSelectOptions, () => []);
    return { promise: promise2, cancel };
  }, []);
  const membersList = form.getFieldValue('members');
  useEffect(() => {
    if (!tabRef.current && form) {
      setActiveKey();
    }
  }, [form]);

  const approvalUsers = useMemo(() => {
    if (_.isEmpty(activeUserOptions) && _.isEmpty(approvalUsersList)) return [];

    let users = [...(approvalUsersList || [])];
    users?.forEach((value, index) => {
      if (value.newMember) {
        users.splice(index, 1);
      }
    });

    // new members which are not present in approval list
    const newMemberList = membersList?.filter((value) => {
      return !users?.find((val) => value.user === val.id);
    });

    newMemberList.forEach(member => {
      const user = find(activeUserOptions, { id: member.user }) || {
        id: member.user,
        label: member.user,
      };
      users.push({
        children: undefined,
        displayName: user.label,
        email: user.email,
        id: user.id,
        label: user.label,
        value: user.id,
        newMember: true,
      });
    })

    // This is to avoid re-fetching approvers in parent component
    if (approversRef?.current) {
      approversRef.current = [...users];
    }

    return users;
  }, [activeUserOptions, approvalUsersList, membersList, approversRef]);

  useEffect(() => {
    if (_.isEmpty(approvalUsers)) return;
    // filter out deleted member
    const approvers = form.getFieldValue("approvers")?.filter((id) => {
      const isEmail = typeof id === "string" && id.includes("@");
      return isEmail || approvalUsers.find((val) => val.id === id);
    });
    form.setFields([
      {
        name: "approvers",
        value: approvers,
      },
    ]);

    // filter out deleted member
    const subscriberUserIds = form
      .getFieldValue("subscriberUserIds")
      ?.filter((id) => {
        return approvalUsers.find((val) => val.id === id);
      });
    form.setFields([
      {
        name: "subscriberUserIds",
        value: subscriberUserIds,
      },
    ]);
  }, [approvalUsers, form]);
  
  const fields = getApprovalWorkflowFields({ approvalUsers: [...approvalUsers], newApprovalFlow, userContext });

  return (
    <Collapse ref={tabRef} activeKey={activeKey} bordered={false} className={`m-b-sm list-collapse`} onChange={setActiveKey}>
      <Collapse.Panel header={<Typography.Text strong><Vocabulary name="exception" /> Approval Workflow</Typography.Text>} key={'approval'} className="no-border">
        <Form layout="vertical"
          form={form}
          initialValues={initialFormValues}
          className="team-form"
        >
          {generateFormFields(fields)}
        </Form>
      </Collapse.Panel>
    </Collapse>
  )
}

export default ApprovalWorkflow;
